import { SHOW_ALERT } from "./actionTypes";

export const showAlertAction = (payload) => ({
  type: SHOW_ALERT,
  payload,
});
